import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgbDropdownConfig, NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pax-dropdown',
  templateUrl: './pax-dropdown.component.html',
  styleUrls: ['./pax-dropdown.component.scss']
})
export class PaxDropdownComponent implements OnInit {
  @Input('placeholder') placeholder = 'Dropdown';
  @Output() onChange = new EventEmitter<any>();
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  private _value = {
    adults: 0,
    children: 0,
    infants: 0
  };

  constructor(config: NgbDropdownConfig) {
    config.autoClose = false;
  }

  ngOnInit() {
  }

  apply() {
    this.dropdown.close();
    this.onChange.emit(this.totalValue);
  }

  cancel() {
    this.dropdown.close();
  }

  get totalValue() {
    return this._value.adults + this._value.children + this._value.infants;
  }

  get adults(): number {
    return this._value.adults;
  }

  set adults(value: number) {
    if (value >= 0 && value !== this._value.adults) {
      this._value.adults = value;
      // this.onChange.emit(this.totalValue);
    }
  }

  get children(): number {
    return this._value.children;
  }

  set children(value: number) {
    if (value >= 0 && value !== this._value.children) {
      this._value.children = value;
      // this.onChange.emit(this.totalValue);
    }
  }

  get infants(): number {
    return this._value.infants;
  }

  set infants(value: number) {
    if (value >= 0 && value !== this._value.infants) {
      this._value.infants = value;
      // this.onChange.emit(this.totalValue);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/pax-dropdown/pax-dropdown.component.ts